import * as R from 'ramda';
const initialState = {
  queryText: 'Garden Hotel',
  allAppKeys: [],
  partnerVectorDbChecks: {},
  ti2ProductRefreshes: {},
  jobDialog: {},
};

const getTi2RefreshMeta = action => {
  const arg = R.pathOr({}, ['args', 0], action);
  return {
    hint: arg.hint || arg.partnerId,
    integrationId: arg.integrationId || arg.app || R.pathOr('', ['integrations', 0, 'integrationId'], arg),
  };
};

const getTi2RefreshErrorMessage = payload => {
  if (typeof payload === 'string') return payload;
  if (!payload) return 'Unable to force refresh Ti2 products.';
  return payload.message || payload.error || R.pathOr('Unable to force refresh Ti2 products.', ['json', 'message'], payload);
};

const updateTi2ProductRefresh = (state, action, refreshState) => {
  const { hint, integrationId } = getTi2RefreshMeta(action);
  if (!hint) return state;
  return {
    ...state,
    ti2ProductRefreshes: {
      ...state.ti2ProductRefreshes,
      [hint]: {
        integrationId,
        ...refreshState,
      },
    },
  };
};

const clearTi2ProductRefreshSuccess = (state, hints) => {
  if (!hints.length) return state;
  return {
    ...state,
    ti2ProductRefreshes: hints.reduce((acc, hint) => {
      const refreshState = acc[hint];
      if (refreshState && refreshState.success) {
        acc[hint] = {
          ...refreshState,
          success: false,
        };
      }
      return acc;
    }, { ...state.ti2ProductRefreshes }),
  };
};

const getStatusCheckResultHints = payload => payload.reduce((acc, curr) => {
  const hint = R.path(['result', 'hint'], curr);
  if (hint) acc.push(hint);
  return acc;
}, []);

const getStatusCheckArgHints = action => R.pathOr([], ['args', 0, 'integrations'], action)
  .map(integration => integration.hint)
  .filter(Boolean);

export default function statusCheckReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'genAi_statusCheck_loadAllAppKeys_SUCCESS':
      return {
        ...state,
        allAppKeys: payload.userAppKeys,
        partnerVectorDbChecks: payload.userAppKeys.reduce((acc, curr) => {
          if (!curr.hint) return acc;
          acc[curr.hint] = {
            ...R.pathOr({}, ['partnerVectorDbChecks', curr.hint], state),
            notChecked: true,
          };
          return acc;
        }, {}),
      };
    case 'genAi_statusCheck_STARTED':
      return {
        ...state,
        partnerVectorDbChecks: {
          ...state.partnerVectorDbChecks,
          ...R.pathOr([], ['args', 0, 'integrations'], action).reduce((acc, curr) => {
            if (!curr.hint) return acc;
            acc[curr.hint] = {
              ...R.pathOr({}, ['partnerVectorDbChecks', curr.hint], state),
              checking: true,
              notChecked: false,
            };
            return acc;
          }, {}),
        },
      };
    case 'genAi_statusCheck_checkStatus_SUCCESS': {
      const nextState = {
        ...state,
        partnerVectorDbChecks: {
          ...state.partnerVectorDbChecks,
          ...payload.reduce((acc, curr) => {
            if (!curr.result) return acc;
            acc[curr.result.hint] = {
              ...R.pathOr({}, ['partnerVectorDbChecks', curr.result.hint], state),
              checking: false,
              ...curr.result,
            };
            return acc;
          }, {}),
        },
      };
      return clearTi2ProductRefreshSuccess(nextState, getStatusCheckResultHints(payload));
    }
    case 'genAi_statusCheck_ERROR':
      return clearTi2ProductRefreshSuccess(state, getStatusCheckArgHints(action));
    case 'genAi_forceRefreshTi2Products_STARTED':
      return updateTi2ProductRefresh(state, action, {
        pending: true,
        success: false,
        error: null,
      });
    case 'genAi_forceRefreshTi2Products_SUCCESS':
      return updateTi2ProductRefresh(state, action, {
        pending: false,
        success: true,
        error: null,
      });
    case 'genAi_forceRefreshTi2Products_ERROR':
      return updateTi2ProductRefresh(state, action, {
        pending: false,
        success: false,
        error: getTi2RefreshErrorMessage(payload),
      });
    case 'genAi_refreshStores_jobCheckStarted': {
      const jobId = R.path([0, 'jobId'], payload);
      return {
        ...state,
        jobDialog: {
          jobId,
          open: true,
          title: 'Refresh Stores Job Output',
        },
      };
    }
    case 'genAi_testProductMatch_jobCheckStarted': {
      const jobId = R.path([0, 'jobId'], payload);
      return {
        ...state,
        jobDialog: {
          jobId,
          open: true,
          title: 'Product Match Test Job Output',
        },
      };
    }
    case 'genAi_refreshStores_checkStatus_SUCCESS':
    case 'genAi_testProductMatch_checkStatus_SUCCESS':
      return {
        ...state,
        jobDialog: {
          ...state.jobDialog,
          jobOutput: R.pick(['status', 'result', 'log'], payload[0] || {}),
        },
      };
    case 'genAi_oncloseJobOutDialog':
      return {
        ...state,
        jobDialog: {},
      };
    default:
      return state;
  }
}
